// @flow

import * as React from 'react';
import type { Node } from 'react';

import './style.scss';

export default function Footer(): Node {
  return (
    <footer className="Footer">
      <p>
        Made with{' '}
        <span role="img" aria-label="love">
          ❤️
        </span>{' '}
        and{' '}
        <span role="img" aria-label="coffee">
          ☕
        </span>
        by Dominik Ilnicki in {new Date().getFullYear()}
        <span role="img" aria-label="COVID emoji">
          🦠
        </span>
      </p>
      <p>
        <a className="main-link" href="https://twitter.com/dominikilnicki">
          Follow me on Twitter
        </a>
        for some web dev & side projects related stuff.
      </p>
      <p>
        If you enjoy this project consider
        <a
          className="main-link"
          href="https://twitter.com/dominikilnicki"
          onClick={() => {
            if (process.env.NODE_ENV === 'production')
              window.analytics.track('Donate');
          }}
        >
          Buying me a coffee.
        </a>
      </p>
    </footer>
  );
}
